/**
 * Created by CCristi <ccovali@mitocgroup.com> on 4/19/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrontendEvent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

var _AbstractEvent2 = require('./AbstractEvent');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Frontend Event
 */
let FrontendEvent = exports.FrontendEvent = function (_AbstractEvent) {
  _inherits(FrontendEvent, _AbstractEvent);

  /**
   * @param {String} args
   */
  function FrontendEvent() {
    var _ref;

    _classCallCheck(this, FrontendEvent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(this, (_ref = FrontendEvent.__proto__ || Object.getPrototypeOf(FrontendEvent)).call.apply(_ref, [this].concat(args)));
  }

  /**
   * @returns {String}
   */


  _createClass(FrontendEvent, [{
    key: 'getEventLevel',
    value: function getEventLevel() {
      return _AbstractEvent2.AbstractEvent.FRONTEND_EVENT_LEVEL;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      return this._data;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'getValidationSchema',
    value: function getValidationSchema() {
      return _joi2.default.object().keys({
        eventLevel: _joi2.default.string().required().allow([_AbstractEvent2.AbstractEvent.FRONTEND_EVENT_LEVEL]),
        engine: _joi2.default.string().required().allow(FrontendEvent.ENGINES),
        time: _joi2.default.number().integer().required(),
        context: _joi2.default.string().required().allow([_AbstractEvent2.AbstractEvent.FRONTEND_CONTEXT]),
        environment: _joi2.default.object().unknown().optional().default({}),
        identityId: _joi2.default.string().required(),
        memoryUsage: _joi2.default.object().unknown().optional().default({}),
        metadata: _joi2.default.object().unknown().optional().default({}),
        location: _joi2.default.string().optional()
      });
    }

    /**
     * @param {Object} event
     * @returns {Object}
     * @private
     */

  }, {
    key: '_enrichWithContextData',
    value: function _enrichWithContextData(event) {
      event = _get(FrontendEvent.prototype.__proto__ || Object.getPrototypeOf(FrontendEvent.prototype), '_enrichWithContextData', this).call(this, event);
      event.location = typeof window !== 'undefined' ? `${window.location.pathname}${window.location.hash}` : null;

      return event;
    }

    /**
     * @returns {String[]}
     */

  }], [{
    key: 'ENGINES',
    get: function get() {
      return ['angular', 'vanilla'];
    }
  }]);

  return FrontendEvent;
}(_AbstractEvent2.AbstractEvent);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/RUM/FrontendEvent.js
// module id = 407
// module chunks = 0